<template>
  <div>
    <h1>Editar tipo_instrumento</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("tipos_instrumentos", ["tipo_instrumento"]),
  },
  methods: {
    ...mapActions("tipos_instrumentos", [
      "ActionNewtipo_instrumento",
      "ActionShow",
    ]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "tipos_instrumentos_list" });
      }
    },
  },
  async created() {
    this.ActionNewtipo_instrumento();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
